import React from 'react'
import RatingContainer from '../RatingSection/RatingContainer'

const FinalClientPage = ({containerObject}) => {
  return (<>
  <br/>
    <div style={{"borderRadius":"10px"}} className={`shadow-lg p-5 bg-white g-0 ${containerObject.attributes.class}`}>
        {containerObject.attributes.imageUrl? <img className="client-img-size mx-auto d-block" src={containerObject.attributes.imageUrl} />:""}
        {containerObject.body?<div dangerouslySetInnerHTML={{__html: containerObject.body}}></div>:""}
        {containerObject.attributes.star?<RatingContainer review={containerObject.attributes.review}/>:""}

    </div>
    <br/>
    </>
  )
}

export default FinalClientPage